/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  channel_type_enum,
  channel_type_style,
  status_enum,
  channel_bind_status_enum,
  MemberSt,
} from 'hiya-common/src/reducers/commonTypes'
import {useSelector} from 'react-redux'

export {channel_type_enum} from 'hiya-common/src/reducers/commonTypes'

// 美元渠道 币商提现限制&手续费预估
export const USDT_CHANNEL_TYPES = [channel_type_enum.USDTTRC20, channel_type_enum.Dreamo_USDT]
export enum TabType {
  兑换金币 = 1,
  薪资流转,
  提取现金,
}
// 计数方式
export enum CountType {
  累计计数 = 1,
  按次计数,
}
export enum historyType {
  提现 = 101,
  薪资扣除 = 102,
  余额转金币 = 103,
  结算薪资 = 201,
  重新结算薪资 = 202,
  提现失败 = 203,
  审核失败 = 204,
}
export enum historyStatus {
  待审核 = 1,
  待打款 = 2,
  审核未通过 = 3,
  已到账 = 4,
  提现失败 = 5,
}
export interface historyListType {
  type: historyType
  time: string
  money: number
  status: number
  status_desc?: string
  show_money: string
  title?: string
  reason?: string
  operate_t?: string
}
// 各种渠道绑定的类型
// 6 他人代收
// 7 payermax_gcash
// 8 公会长代收
// export enum channel_type_enum {
//   Identity = 1,
//   Payoneer = 2,
//   PayerMaxBank = 3,
//   AirWallexBank = 4,
//   PayerMaxFawry = 5,
//   他人代收 = 6,
//   PayermaxGcash = 7,
//   公会长代收 = 8,
//   NormalCoin = 1000,
//   TraderCoin = 1001,
// }

// payoneer 绑定状态
// 0未绑定 1生效中 2待确认 3被拒绝 4未找到
export enum PAYONEER_BIND_STATUS {
  未绑定 = 0,
  生效中 = 1,
  待确认 = 2,
  被拒绝 = 3,
  未找到 = 4,
}

// 银行绑定状态
export enum BANK_STATUS {
  UnDetail = 0, // 0未填写
  Check = 1, // 1审核中
  Pass = 2, // 2审核通过
  Reject = 3, // 3审核拒绝
  Delete = 4, // 4删除
}

// app工会长薪资转金币页面配置信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90607041
export const wage_to_coins_cfg = createAsyncThunk(
  'SalaryWallet/wage_to_coins_cfg',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'wallet'>>>(
      '/live/union/wage_to_coins_cfg',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 公会长薪资转金币 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41449707
export const wage_to_coins = createAsyncThunk(
  'withdraw_union_leader_wage_to_coins',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/union/wage_to_coins',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取绑定渠道信息  http://wiki.xunlei.cn/pages/viewpage.action?pageId=105290331
export const get_pay_channel = createAsyncThunk(
  'SalaryWallet/get_pay_channel',
  async (arg: {need_trans_account?: boolean}, store: any) => {
    const resp = await http.post('/live/settle/get_pay_channel', {
      ...store.getState().env.deviceinfo,
      target_mid: store.getState().env.deviceinfo.h_m,
      only_need_pass: false,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取收款窗口ids
export const get_receive_cashout_ids = createAsyncThunk(
  'AnchorCenter/get_receive_cashout_ids',
  async (p: {channel: channel_type_enum}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: {
          id: string // 收款id，唯一
          t_range: string // 时间
        }[]
      }>
    >('/live/union/get_receive_cashout_ids', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
// 公会长获取代收记录概览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122789700
export const get_union_owner_agent_overview = createAsyncThunk(
  'AnchorCenter/get_union_owner_agent_overview',
  async (
    p: {
      receive_cash_out_id: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/settle/get_union_owner_agent_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data.data
  }
)
export enum rate_kind_enum {
  实时 = 1,
  固定 = 2,
}
export enum fee_kind_enum {
  固定金额 = 1,
  最低加固定比例 = 2,
}
export enum agio_base_kind_enum {
  实时 = 1,
  配置固定 = 2,
  其他 = 3,
}
export enum fee_base_kind_enum {
  固定金额 = 1,
  最低加固定比例 = 2,
  无 = 3,
}
export interface wage_to_channel_res_ensure_type {
  estimate_arrival_amount: any
  estimate_fee: any
  money: number
  member: MemberSt
  channel_base: {
    type: channel_type_enum
    name: string
    icon: string
    account?: string
    iban?: string
  }
  remark?: string // 提示：该渠道手续费较高，建议选择其他方式提现
  agio_base: {
    kind: agio_base_kind_enum // 汇率类型 1实时 2配置(固定) 3其他
    amount: number // 转换的数目
    currency: string // 转换的币种
    icon: string
    exchange_ratio?: number // 兑换比例
  }
  is_free: boolean //   true：免手续费
  fee_base: {
    kind: fee_base_kind_enum
    currency: string // 币种
    fixed_fee: number // 固定金额
    min_fee: number // 最低
    fee_ratio: number // 固定比例
    max_fee: number // 最高
  }
  order?: {
    status: string // 状态
    ct: string // 提交时间
    operator: string // 提交人
    op_cash_id: string // 提现窗口id
    id: number // 操作id
    reason: string
  }
  time_desc: string // 到账时间
}
export interface wage_to_channel_res_type {
  channel_type: channel_type_enum
  ensure: wage_to_channel_res_ensure_type
  err_msg?: string
}
// 薪资渠道提现 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105285961
export const wage_to_channel = createAsyncThunk(
  'SalaryWallet/wage_to_channel',
  async (
    arg: {
      ensure_exchange: 0 | 1 // 0 计算可得手续费，提示文案 1确认转换
      money: number
      channel_type: channel_type_enum
      target_mid?: number
      channel_id: string
      xcErrorToast?: boolean
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<wage_to_channel_res_type>>(
      '/live/settle/wage_to_channel',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// 获取公会长信息
export const union_owner_info_by_mid = createAsyncThunk(
  'SalaryWallet/union_owner_info_by_mid',
  async (arg, store: any) => {
    const resp = await http.post('/live/settle/union_owner_info_by_mid', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 获取公会长是否能代收信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105294321
export const getWalletLog = createAsyncThunk(
  'SalaryWallet/getWalletLog',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{is_owner_allow_agent?: boolean}>>(
      '/live/settle/app_wallet_log',
      {
        ...store.getState().env.deviceinfo,
        kind: 3,
        offset: 0,
        page_size: 10,
      }
    )
    return resp.data.data
  }
)
export interface pay_channel_list_item {
  id: string // 数据主键
  title: string // 标题
  desc: string // 描述
  channel: channel_type_enum // 通道类型
  status: status_enum // 0未填写 1审核中 2审核通过 3审核拒绝 4删除
  bind_status: channel_bind_status_enum // 0未绑定 1生效中 2待确认 3被拒绝 4未找到
  show_status: string // 展示状态描述
  channel_account: string // 账户id
  default_channel: channel_type_enum
  style?: channel_type_style
  category: number // 类别 1转金币 2薪资流转 3提取现金
  is_cashout_time: boolean // 该渠道是否是提现窗口期 true:是
  to_member?: MemberSt // 如果是他人代收，就有对方的信息
}
// 兑换比例
export interface ratio_item {
  origin_amount?: number // 原始币种数量
  target_amount?: number // 兑换目标币种数量
  amount_icon?: string
  hiya_icon?: string
  // 原来的
  range_left?: number
  range_right?: number
  ratio_left?: number
  ratio_right?: number
}
export interface ratio_info_item {
  channel: channel_type_enum // 渠道类型
  min: number // 最低转换
  max: number // 最高转换
  ratio: ratio_item[] // 兑换比例
}
interface InitialStateType {
  wallet: {
    // 总余额 -----
    total_balance?: number
    // 是否暂时new ---
    is_new?: boolean
    // 可提现的余额
    balance?: number
    // app中审核的余额
    auditing_balance?: number
    // 币商金币 最小的转换数
    divide_money?: number
    // 普通金币 允许的最少转换数（美元）
    min_money?: number

    // 薪资转金币开关
    wage_to_coins_switch?: boolean
    // 币商配置列表
    ra_ratio_list?: Array<{range: string; ratio: string}>
    // 普通配置列表
    ratio_list?: Array<{range: string; ratio: string}>

    err_msg?: string
    money?: number
    coins?: number
  }
  pay_channel: {
    max_cash_out_info?: {
      no_show_channles: channel_type_enum[] // 不展示的渠道 如果是-1，则全部不展示
      limit_kind: number // 限制类型 1固定值 2全公会直播总收入*比例 3全公会(直播+流转)总收入*比例
      percent: number // 百分比
      cfg_max_amount: number // 最大薪资数
      could_amount: number // 可以提取的的最大薪资数
    }
    default_channel?: channel_type_enum
    icon_list?: {
      name: string
      img: string
      url: string
      sign_status: string
    }[]
    list?: pay_channel_list_item[]
    is_cashout_time?: boolean
    is_allow_others_collection?: boolean // 是否允许他人代收
    is_owner_allow_agent?: boolean // 是否允许公会长代收
    ra_usdt_limit_amount?: number // 提现USDT限制金额
    category_list?: {
      icon: string
      name: string
      category: number // 类别 1转金币 2薪资流转 3提取现金
    }[]
    balance_info?: {
      total: number // 总余额
      overage: number // 可提现余额
      frozen_overage: number // 冻结余额
      auditing_overage: number // 审核余额
      is_new: boolean // 是否有新入账
    }
    ratio_info?: ratio_info_item[]
  }
  unionInfo: {
    member?: MemberSt
    is_owner_allow_agent?: boolean
  }
  curChannel?: channel_type_enum
  curChannelInfo?: pay_channel_list_item
  exchangeObj?: any
  union_owner_agent_overview?: any
}

const initialState: InitialStateType = {
  wallet: {},
  pay_channel: {},
  unionInfo: {},
  curChannel: null,
  exchangeObj: {},
  union_owner_agent_overview: {},
}

export const SalaryWalletSlice = createSlice({
  name: 'SalaryWallet',
  initialState,
  reducers: {
    getCurChannel: (state, action: PayloadAction<channel_type_enum>) => {
      Object.assign(state, {
        curChannel:
          action.payload || state.pay_channel?.default_channel || undefined,
        curChannelInfo: state.pay_channel?.list?.find(
          (c) =>
            c.channel ===
            (action.payload || state.pay_channel?.default_channel || undefined)
        ),
      })
    },
    getCurCategoryList: (state, action: PayloadAction<number>) => {
      Object.assign(state.pay_channel, {
        list: action.payload
          ? state.pay_channel?.list?.filter(
              (c) => c.category === action.payload
            )
          : state.pay_channel?.list,
      })
    },
    setExchangeObj: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        ...state,
        exchangeObj: action.payload || {},
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(wage_to_coins_cfg.fulfilled, (state, action) => {
      Object.assign(state.wallet, action.payload)
    })
    builder.addCase(get_pay_channel.fulfilled, (state, action) => {
      Object.assign(state.pay_channel, action.payload)
    })
    builder.addCase(union_owner_info_by_mid.fulfilled, (state, action) => {
      Object.assign(state.unionInfo, action.payload)
    })

    builder.addCase(getWalletLog.fulfilled, (state, action) => {
      Object.assign(state.unionInfo, {
        is_owner_allow_agent: action.payload.is_owner_allow_agent,
      })
    })
    builder.addCase(
      get_union_owner_agent_overview.fulfilled,
      (state, action) => {
        Object.assign(state.union_owner_agent_overview, action.payload || {})
      }
    )
  },
})
export default SalaryWalletSlice.reducer
export const SalaryWalletActions = SalaryWalletSlice.actions
export const useSalaryWalletState = () => {
  const data = useSelector((state) => state.SalaryWallet)
  return data
}
